module.exports = __webpack_public_path__ + "static/media/item5.d0a92ef2.jpg";